var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReelsViews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.666992,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#CDEFF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4999 19.2753C13.5083 19.2753 11.8916 17.6586 11.8916 15.6669C11.8916 13.6753 13.5083 12.0586 15.4999 12.0586C17.4916 12.0586 19.1083 13.6753 19.1083 15.6669C19.1083 17.6586 17.4916 19.2753 15.4999 19.2753ZM15.4999 13.3086C14.1999 13.3086 13.1416 14.3669 13.1416 15.6669C13.1416 16.9669 14.1999 18.0253 15.4999 18.0253C16.7999 18.0253 17.8583 16.9669 17.8583 15.6669C17.8583 14.3669 16.7999 13.3086 15.4999 13.3086Z",
    fill: "#00A4D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5004 23.1837C12.3671 23.1837 9.40872 21.3504 7.37539 18.1671C6.49206 16.7921 6.49206 14.5504 7.37539 13.1671C9.41706 9.98372 12.3754 8.15039 15.5004 8.15039C18.6254 8.15039 21.5837 9.98372 23.6171 13.1671C24.5004 14.5421 24.5004 16.7837 23.6171 18.1671C21.5837 21.3504 18.6254 23.1837 15.5004 23.1837ZM15.5004 9.40039C12.8087 9.40039 10.2337 11.0171 8.43372 13.8421C7.80872 14.8171 7.80872 16.5171 8.43372 17.4921C10.2337 20.3171 12.8087 21.9337 15.5004 21.9337C18.1921 21.9337 20.7671 20.3171 22.5671 17.4921C23.1921 16.5171 23.1921 14.8171 22.5671 13.8421C20.7671 11.0171 18.1921 9.40039 15.5004 9.40039Z",
    fill: "#00A4D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReelsViews);
export default __webpack_public_path__ + "static/media/reels_views.24e6076b99feb9e9699b096bb21cffc8.svg";
export { ForwardRef as ReactComponent };